var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import Anchor from '@telia-front/anchor';
import Container from '@telia-front/container';
import Grid, { GridColumn } from '@telia-front/grid';
import Heading from '@telia-front/heading';
import List, { ListItem } from '@telia-front/list';
import Pagination from '@telia-front/pagination';
import Section from '@telia-front/section';
import Separator from '@telia-front/separator';
import Tag from '@telia-front/tag';
const TemplateTeliaWebNewsList = (props) => {
    const getAnchorProps = () => {
        if (props.type === 'employee') {
            return {
                color: 'employee',
            };
        }
        else {
            return {
                isTextColor: true,
            };
        }
    };
    const getListItems = () => {
        return props.items.map((item, key) => {
            const { isoDate, displayDate, title } = item, rest = __rest(item, ["isoDate", "displayDate", "title"]);
            return (React.createElement(ListItem, { key: key },
                React.createElement(Grid, { className: "text-small", gutter: "xsmall" },
                    React.createElement(GridColumn, { width: ['xs'] },
                        React.createElement("time", { dateTime: isoDate }, displayDate)),
                    item.tag && (React.createElement(GridColumn, { width: ['xs'] },
                        React.createElement(Tag, Object.assign({ size: "tiny" }, item.tag))))),
                React.createElement(Anchor, Object.assign({}, rest, getAnchorProps(), { isUnderlined: false, className: "h5" }), title)));
        });
    };
    const renderEmployeeContent = () => (React.createElement(Section, Object.assign({ backgroundColor: "background-5", isFull: true }, props.section),
        React.createElement(Container, null, renderContent())));
    const renderContent = () => {
        const visualHeadingLevel = props.type === 'employee' ? 'h3' : 'h2';
        const { headingLevel = 1 } = props;
        return (React.createElement(React.Fragment, null,
            React.createElement(Heading, { level: headingLevel, className: visualHeadingLevel }, props.title),
            React.createElement(Separator, { spacing: "small", color: "invisible" }),
            React.createElement(List, { type: "unstyled" }, getListItems()),
            React.createElement(Separator, { spacing: "small", color: "invisible" }),
            React.createElement(Pagination, { pages: 20, currentPage: 1, color: props.type === 'employee' ? 'employee' : undefined })));
    };
    return props.type === 'employee' ? renderEmployeeContent() : renderContent();
};
export { TemplateTeliaWebNewsList as default };
